import * as yup from 'yup';
export const addCategoryValidation = yup.object({
  name: yup.string().required('*required')
});
export const editCategoryValidation = yup.object({
  name: yup.string()
});

export const addServiceValidation = yup.object({
  title: yup.string().required('*required')
});
